import { Button, ButtonProps, Icons } from '@cast/design-system';
import { useIsTrialClusterConnectionBlocked } from '@cast/shared-trial-ui';

type ConnectClusterButtonProps = {
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  onConnectCluster?: () => void;
  disabled?: boolean;
};

export const ConnectClusterButton = ({
  variant = 'secondary',
  size = 'md',
  onConnectCluster,
  disabled = false,
}: ConnectClusterButtonProps) => {
  const isTrialClusterConnectionBlocked = useIsTrialClusterConnectionBlocked();

  return (
    <Button
      variant={variant}
      size={size}
      startIcon={<Icons.Plus size={20} />}
      testId="connect-cluster-button"
      onClick={onConnectCluster}
      disabled={
        disabled || isTrialClusterConnectionBlocked || !onConnectCluster
      }
    >
      Connect cluster
    </Button>
  );
};
